import { render, staticRenderFns } from "./comp4.vue?vue&type=template&id=34c8c8dc"
import script from "./comp4.vue?vue&type=script&lang=js"
export * from "./comp4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports